import { render } from "./serviceExplain.vue?vue&type=template&id=064c31a5&scoped=true&ts=true"
import script from "./serviceExplain.vue?vue&type=script&lang=ts"
export * from "./serviceExplain.vue?vue&type=script&lang=ts"

import "./serviceExplain.vue?vue&type=style&index=0&id=064c31a5&lang=less&scoped=true"

import exportComponent from "/workspace/source-code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-064c31a5"]])

export default __exports__